module.exports = __webpack_public_path__ + "img/cadd-modelling-thumb.d6c55576.jpg";